<template>
  <div class="contentBox">
    <div class="contentBlock fade-in-section">
      <img :src="bannerImg" class="bannerImgItem" />
    </div>
    <div 
      v-for="i in qaNum" 
      :key="i" 
      class="contentBlock qaImgBlock fade-in-section" 
      @click="toggleImage(i)"
    >
      <img :src="activeImages[i] ? qaImg_a[i] : qaImg_q[i]" />
    </div>
  </div>
</template>

<script>
import "./index.css";
import bannerImg from "@/page/cptthanhvancompany/components/img/question1.png";

const QA_NUM = 9;

const qaImg_q = {};
for (let i = 1; i <= QA_NUM; i++) {
  qaImg_q[i] = require(`@/page/cptthanhvancompany/components/img/qa_q${i}.png`);
}

const qaImg_a = {};
for (let i = 1; i <= QA_NUM; i++) {
  qaImg_a[i] = require(`@/page/cptthanhvancompany/components/img/qa_a${i}.png`);
}

export default {
  data() {
    return {
      qaNum : QA_NUM,
      bannerImg,
      qaImg_q,
      qaImg_a,
      activeImages: Array(QA_NUM + 1).fill(false)
    };
  },
  mounted() {
    this.InitPage();
  },
  methods: {
    InitPage(){
      window.scrollTo({ top: 0 });
      const fadeInSections = document.querySelectorAll('.fade-in-section');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
      });
    }, {
        threshold: 0.1
    });
      fadeInSections.forEach(section => {
          observer.observe(section);
      });
    },
    toggleImage(index) {
      this.$set(this.activeImages, index, !this.activeImages[index]);
    }
  }
};
</script>

<style scoped>
.qaImgBlock {
  cursor: pointer;
  margin-bottom: 60px;
  padding: 0px 160px;
}
</style>